/**
 * Legacy imports. You should have a real good reason to update this file !
 */
window.$ = window.jQuery = require('jquery');

// JS PART
require('jquery-form');
require('jquery-ui/ui/widgets/dialog');
require('lodash');
window.axios = require('axios');
require('../../vendor/jquery.contextmenu.js');

import Translator from "gettext-translator";

window.translations = window.translations != undefined ? window.translations : {"domain":null,"plural-forms":"nplurals=2; plural=n > 1;","messages":[]};
window.i18n = new Translator(window.translations);

require('intl-tel-input/build/js/utils.js');
require('intl-tel-input');

window.toastr 	= require('toastr');

var files	= {};

var context = require.context('../../../../../public/ressources/common/js/', false, /\.js$/);
context.keys().forEach(function(filename){
  files[filename] = context(filename);
});

var context = require.context('../../../../../public/ressources/public/js/', false, /\.js$/);
context.keys().forEach(function(filename){
  files[filename] = context(filename); 
});

var context = require.context('Core/commons/', false, /\.js$/);
context.keys().forEach(function(filename){
  files[filename] = context(filename);
});

var context = require.context('Core/public/', false, /\.js$/);
context.keys().forEach(function(filename){
  files[filename] = context(filename);
});

var lodash = window.lodash			= require("lodash");
window.moment = require('moment');
require('moment-timezone');

// CSS PART
require('@sellsy/styleguide/dist/public.min.css');